import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import styles from './ActionsCellButton.module.scss';

interface IActionCellButtonInterface {
    text: string;
    disabled?: boolean;
    handleClick: () => void;
    track: TrackingEvent;
}

const ActionsCellButton: React.FC<IActionCellButtonInterface> = (props: IActionCellButtonInterface) => {
    const handleClick = () => {
        props.handleClick();
        trackingService.track(props.track);
    };

    return (
        <button type="button" className={styles.actions_cell_button} onClick={handleClick} disabled={props.disabled}>
            {props.text}
        </button>
    );
};

export default ActionsCellButton;
